import React, { useEffect, useState} from "react";
import { Dialog, Input, tCell, toastMessage } from "../utils";
import { useAddPlantCommentMutation } from "../../api/vmsSlice";
import { useGetPlantComments } from "../../services/hooks";
import { GenericTableInfinite } from "../utils/GenericTable";
import dayjs from "dayjs";
const defaultForm = {
	name: "",
	comment:""
};

export function Comment({ onClose, open, plantData }) {
    const[formData, setFormData]=useState(defaultForm)
    const [errors, setErrors] = useState({});
    const [handleAddPlantComment] = useAddPlantCommentMutation();
	const handleClose = () => {
		setFormData(defaultForm);
        setErrors({});
		onClose();
        
	};
    const validatePayload =(formData)=>{
        let error ={}
        if(!formData.comment){
            error.comment= "This field is required"
        }
        setErrors(error)
        return Object.keys(error).length === 0;
    }
    const handleFormSubmit =async()=>{
        
        const payload={
            ...formData,
            plantId:plantData?.plantId
        }
		// console.log("Payload", payload)
        if (!validatePayload(payload)) {
			return;
		}
	    const {
            data: { error, message },
        } = await handleAddPlantComment(payload)
        if (error) {
            toastMessage(false, message);
        } else {
            toastMessage(true, message);
            handleClose();
        }
    }
    const handleInput = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};
    return (
        <Dialog size="xs" open={open} handleClose={handleClose} handleSubmit={handleFormSubmit} title="Add Comment" CancelText="Cancel" SubmitText="Add Comment">
            <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "18px 16px", alignItems: "center", marginBottom: "16px" }}>
                <Input label="Author" placeholder="Enter Author Name" name="name" value={formData.name} onChange={handleInput}  />
                <Input label="Comment" placeholder="Write Comment" name="comment" value={formData.comment} onChange={handleInput} error={errors.comment} multiline required />
            </div>
        </Dialog>
    );
}

export function ViewComment({onClose, open, plantData}){
    const {plantComments, count, message, isLoading, getPlantComments } = useGetPlantComments({plantId: plantData?.plantId});
    useEffect(()=>{
        if (plantData?.plantId) {
            getPlantComments({ plantId: plantData?.plantId });
        }
    }, [plantData])
    const header= ["Created At","Author", "Comments"]
    const rows =
        plantComments?.map((d, i) => {
            return [
                tCell(dayjs(d.lastActive).format("DD MMM YYYY, hh:mm A")|| "-"),
                tCell(d.author || "-"),
                tCell(d.comment || "-")
            ];
        }) || [];
	const handleClose = () => {
		onClose();
	};
    return (
        <Dialog size="sm" open={open} handleClose={handleClose} title="View Comments" noBtn>
            {isLoading ? (
                <div style={{ textAlign: "center", padding: 20 }}>Loading...</div>
            ) : (
                <GenericTableInfinite
                    header={header}
					rows={rows}
					isLoading={isLoading}
                />
            )}
        </Dialog>
    );
}